import TextBox from './src/TextBox'

TextBox.install = function (Vue) {
    Vue.component(TextBox.name, TextBox);
};

export default TextBox;